<template>
  <div
    data-id="cta-link"
  >
    <a
      :href="href"
      :target="external ? '_blank' : '_self'"
      class="cta-link"
      :class="{
        'mt-4!': ['2xs', 'xs', 'sm'].includes(size),
      }"
      tabindex="0"
    >
      <span
        :class="{
          'text-sm!': ['2xs', 'xs', 'sm'].includes(size),
        }"
      >{{ text }}</span>
      <FaIcon
        name="arrow-right"
        :iconSize="size"
        icon-style="regular"
      />
    </a>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  href: {
    type: String,
    required: true
  },
  external: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    required: true
  },
  size: {
    type: String as () => '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl',
    default: 'lg',
    required: false
  }
});
</script>
